import UploadsPhotoAiStudy from './UploadsPhotoAiStudy';

export default UploadsPhotoAiStudy;
